import GeneratedToAddressesApi from "./generated/GeneratedToAddressesApi"

class ToAddressesApi extends GeneratedToAddressesApi {

}

export const toAddressesApi = new ToAddressesApi()
